import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import DefaultButton from "../../components/DefaultButton";
import {
  getEffortGearCode,
  getEffortGearQty,
  getEffortGearSize,
  getEffortMeshSize,
  getInitialGearState,
  validateGear,
} from "../../constants/Effort";
import GearCode from "../../components/GearCode";
import GearQty from "../../components/GearQty";
import GearSize from "../../components/GearSize";
import MeshSize from "../../components/MeshSize";
import {
  getGearCodeValidation,
  validateEffortSet1,
} from "../../constants/effortValidations";
import { getTripTripId } from "../../constants/vtrTrip";
import { Navigate, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { success } from "../../constants/colors";

function EffortPage1(props) {
  const { actions } = props;
  const location = useLocation();
  const { auth, vtrTrip, helpText, validation } = useSelector((state) => state);
  const { report_type } = location.state.trip;
  const [values, setValues] = useState({
    gearcode: "",
    gearname: "",
    show_mesh_size: false,
    mesh_size_minimum: null,
    mesh_size_maximum: null,
    show_gear_qty: false,
    gear_qty_minimum: null,
    gear_qty_maximum: null,
    show_gear_size: false,
    gear_size_minimum: null,
    gear_size_maximum: null,
    gearqty: "",
    gearsize: "",
    mesh_size: "",
    effortNr: null,
    trip_id: null,
    reportType: report_type,
  });
  const [gearValidation, setGearValidation] = useState(null);

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleGearCodeChange = (event, reason) => {
    let newState = new getInitialGearState();
    if (reason) {
      //Save the new values when selected
      if (reason.hasOwnProperty("CODE") && reason.hasOwnProperty("NAME")) {
        let gearValidations = validation.validations.gear;
        if (!Array.isArray(gearValidations)) {
          console.error("Not an array:", gearValidations);
          return false;
        }
        newState.gearcode = reason.CODE;
        newState.gearname = reason.NAME;
        newState = validateGear(gearValidations, reason.CODE, newState);
      }
      // * clearing not required values for PTLL and PTCL
      if (report_type === "2" && ["PTLL", "PTCL"].includes(newState.gearcode)) {
        newState.gearsize = "";
        newState.gearqty = "";
        newState.number_of_hauls = "";
        newState.tow_soak_time = "";
      }
    }
    setValues({ ...values, ...newState });
  };

  const handleGearCodePreferenceChange = (event) => {
    event.preventDefault();
    let gearCode = event.currentTarget.dataset.gearCode;
    if (!gearCode) {
      console.log("No gear_code provided");
      return;
    }

    let newState = new getInitialGearState();
    let gearValidations = validation.validations.gear;
    if (!Array.isArray(gearValidations)) {
      console.error("Not an array:", gearValidations);
      return false;
    }
    newState.gearcode = gearCode;
    newState = validateGear(gearValidations, gearCode, newState);
    // * clearing not required values for PTLL and PTCL
    if (report_type === "2" && ["PTLL", "PTCL"].includes(newState.gearcode)) {
      newState.gearsize = "";
      newState.gearqty = "";
      newState.number_of_hauls = "";
      newState.tow_soak_time = "";
    }

    setValues({ ...values, ...newState });
  };

  const handleGearPreferenceChange = (event) => {
    event.preventDefault();
    let newValue = event.currentTarget.dataset.newValue;
    let field = event.currentTarget.dataset.field;
    if (!newValue) {
      console.log("No new value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }

    let newState = {};
    newState[field] = newValue;
    setValues({ ...values, ...newState });
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    actions.setError(errors);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const _next = (event, value) => {
    event.preventDefault();
    const gearValidations = validation.validations.gear;
    let errors = validateEffortSet1(values, gearValidations);
    actions.setError(errors);
    if (errors.length > 0) {
      console.error("effort-page1", errors);
      return;
    }
    if (value === "Save") {
      actions.updateEffort(values, auth.client_id);
    }
  };

  useEffect(() => {
    let gearCode = getEffortGearCode(location.state);
    let currentGearState = new getInitialGearState();
    let validatedGearState = validateGear(
      validation.validations.gear,
      gearCode,
      currentGearState
    );
    currentGearState.gearcode = gearCode;
    if (validatedGearState.show_gear_qty === true) {
      currentGearState.gearqty = getEffortGearQty(location.state);
    }
    if (validatedGearState.show_gear_size === true) {
      currentGearState.gearsize = getEffortGearSize(location.state);
    }
    if (validatedGearState.show_mesh_size === true) {
      currentGearState.mesh_size = getEffortMeshSize(location.state);
    }
    currentGearState.effortNr = location.state.effortNr;
    currentGearState.trip_id = getTripTripId(location.state);
    setValues({ ...values, ...currentGearState });
    actions.resetTripRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let codeValidation = getGearCodeValidation(
      values.gearcode,
      validation.validations.gear
    );
    setGearValidation(codeValidation);
  }, [validation.validations.gear, values.gearcode]);

  if (vtrTrip.redirect === true) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/effort-review`}
        state={{
          trip_id: values.trip_id,
          client_id: auth.client_id,
          effortNr: values.effortNr,
        }}
      />
    );
  }

  return (
    <div className="margAll10">
      <GearCode
        changeHandler={handleGearCodeChange}
        gearCodeOptions={validation.validations.gear}
        gearcode={values.gearcode}
        gearname={values.gearname}
        gear_preference={
          auth.vtr_preferences.gear ? auth.vtr_preferences.gear : []
        }
        handleGearCodePreferenceChange={handleGearCodePreferenceChange}
        helpText={helpText.helpText}
        reportType={values.reportType}
      />
      {values.show_gear_qty && (
        <GearQty
          gearqty={values.gearqty}
          gearcode={values.gearcode}
          handleInputChange={handleInputChange}
          handleGearPreferenceChange={handleGearPreferenceChange}
          gear_preference={
            auth.vtr_preferences.gear ? auth.vtr_preferences.gear : []
          }
          helpText={helpText.helpText}
          validation={gearValidation}
        />
      )}
      {values.show_gear_size && (
        <GearSize
          gearsize={values.gearsize}
          gearcode={values.gearcode}
          handleInputChange={handleInputChange}
          handleGearPreferenceChange={handleGearPreferenceChange}
          gear_preference={
            auth.vtr_preferences.gear ? auth.vtr_preferences.gear : []
          }
          helpText={helpText.helpText}
          validation={gearValidation}
        />
      )}
      {values.show_mesh_size && (
        <MeshSize
          mesh_size={values.mesh_size}
          gearcode={values.gearcode}
          handleInputChange={handleInputChange}
          handleGearPreferenceChange={handleGearPreferenceChange}
          gear_preference={
            auth.vtr_preferences.gear ? auth.vtr_preferences.gear : []
          }
          helpText={helpText.helpText}
          validation={gearValidation}
        />
      )}

      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton changeHandler={_cancel} buttonText={"Cancel"} />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton
              changeHandler={_next}
              buttonText={"Save"}
              bgColor={success}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(EffortPage1);
